import classNames from "classnames";
import type { FC } from "react";

import type { CustomRef } from "@/utils/types";

import { DividerVariant } from "./types";

type DividerProps = {
  variant: DividerVariant;
} & CustomRef<HTMLDivElement>;

export const Divider: FC<DividerProps> = ({ variant, ref }) => (
  <div
    ref={ref}
    className={classNames("if border-top-solid border-width-1 min-w-100p", {
      "border-color-beige-500": variant === DividerVariant.LIGHT,
      "border-color-brown-600": variant === DividerVariant.DARK,
    })}
  ></div>
);
